@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div class="popup_main_div add_edit_matter_main" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  @if (_data.Type !== 'duplicate') {
    <h2 cdkDragHandle mat-dialog-title class="title-withswitch">
      <span>{{ _data.Type == 'new' ? 'Create' : 'Edit' }} Invoice Template</span>
      <button
        class="close-btn"
        mat-icon-button
        [mat-dialog-close]="false"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </h2>
  }
  @if (_data.Type === 'duplicate') {
    <h2 cdkDragHandle mat-dialog-title class="title-withswitch">
      {{ _data.Type == 'duplicate' ? 'Duplicate' : '' }} Invoice Template
      <button
        class="close-btn"
        mat-icon-button
        [mat-dialog-close]="false"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </h2>
  }

  <div
    [formGroup]="InvoiceTemplatePopup"
    class="one mat-dialog-content px-6 pt-6 pb-0"
    fxLayout="column"
  >
    <div class="exoansionpanel-wrap">
      <div mat-align-tabs="start" fxLayout="column" style="margin-top: 0px">
        @if (this._data.Type == 'new' || this._data.Type == 'duplicate') {
          <p class="py-[12px] font-[12px]">*Please enter template name without spaces</p>
        }
        @if (this._data.Type == 'edit') {
          <p class="py-[12px] font-[12px]">
            *Please enter template name without spaces - If you change the name this will make a
            copy of the original template.
          </p>
        }
        <mat-form-field class="a" appearance="outline" fxFlex="100" class="mb-4">
          <mat-label>Template Name</mat-label>
          <input
            type="text"
            matInput
            formControlName="TemplateId"
            placeholder="Template Name"
            [(ngModel)]="GTemplateId"
            required
            [readonly]="_data.Type === 'edit' ? true : false"
            [ngClass]="
              _data.Type === 'edit' ? 'disabled-click-cursor ribbon-section' : 'ribbon-section'
            "
          />
        </mat-form-field>
      </div>

      <mat-expansion-panel
        label="General"
        mat-align-tabs="start"
        fxLayout="column"
        [expanded]="step === 0"
      >
        <mat-expansion-panel-header class="Bold_panel_header">
          Font Settings
        </mat-expansion-panel-header>
        <!-- <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
          <mat-label>Invoice Template Name</mat-label>
          <input type="text" matInput formControlName="TEMPLATENAME">
        </mat-form-field> -->
        <mat-form-field class="a" appearance="outline" fxFlex="33" class="pr-10">
          <mat-label>Font list</mat-label>
          <mat-select #value formControlName="TEMPLATEFONT">
            @for (FontList of GLOBLE_DROPDOWN_CONST.FontList; track FontList) {
              <mat-option value="{{ FontList }}">{{ FontList }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="a" appearance="outline" fxFlex="33" class="pr-10">
          <mat-label>Font Size</mat-label>
          <input type="text" matInput formControlName="TEMPLATEFONTSIZE" />
          <!-- <mat-select #value  formControlName="TEMPLATEFONT">
            <mat-option *ngFor="let FontNumber of GLOBLE_DROPDOWN_CONST.FontNumber" value="{{FontNumber}}">{{FontNumber}}
            </mat-option>
          </mat-select> -->
        </mat-form-field>
        <mat-form-field class="a" appearance="outline" fxFlex="33" class="pr-10">
          <mat-label>Font Colour</mat-label>
          <input type="color" matInput formControlName="TEMPLATEFONTCOLOUR" />
        </mat-form-field>
      </mat-expansion-panel>
    </div>

    <div class="exoansionpanel-wrap">
      <mat-expansion-panel label="General" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          Header Settings
        </mat-expansion-panel-header>
        <div>
          <mat-form-field class="a" appearance="outline" fxFlex="50" class="pr-10">
            <mat-label>Header Style</mat-label>
            <mat-select
              #value
              formControlName="HEADERSTYLE"
              (selectionChange)="imageSelect($event)"
            >
              @for (HeaderStyle of GLOBLE_DROPDOWN_CONST.HeaderStyle; track HeaderStyle) {
                <mat-option value="{{ HeaderStyle }}">{{ HeaderStyle }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- <mat-form-field class="a" appearance="outline" fxFlex="50" class="pr-10"  *ngIf="!hadderSettingImage">
            <mat-label>Header Image File</mat-label>
            <input  matInput formControlName="HEADERIMAGEFILE">
          </mat-form-field> -->
          <mat-form-field class="a" appearance="outline" fxFlex="50" class="pr-10">
            <mat-label>Header Height</mat-label>
            <input type="number" matInput formControlName="HEADERHEIGHT" />
          </mat-form-field>
        </div>
        <!-- imge section start  -->
        @if (hadderSettingImage) {
          @if (finalfileToUpload == '' || (finalfileToUpload && finalfileToUpload[0]) == '') {
            <div
              class="fileupload-block mt-4 pr-10"
              appFileDragNDrop
              (filesChangeEmiter)="onFileChange($event)"
            >
              <input
                type="file"
                name="file"
                id="file"
                (change)="onFileChange($event.target.files)"
                accept="image/*"
              />
              <label for="file">
                <span class="textLink">
                  <mat-icon>cloud_upload</mat-icon>
                  Select your file or Drop it here!
                </span>
              </label>
            </div>
          }
        }
        <!-- <div  class="itemimge mb-10" *ngIf="finalfileToUpload != '' && finalfileToUpload && finalfileToUpload[0] !== ''">
          <img style="border-radius: 4px;width: -webkit-fill-available !important;" [src]="(finalfileToUpload && finalfileToUpload[0] !== '')?finalfileToUpload[0]:''"  alt="Preview image" />
          <mat-icon class='cursor'  (click)="remove()">clear</mat-icon>
        </div> -->
        <!-- <span class="material-icons">zoom_out</span> -->
        @if (finalfileToUpload != '' && finalfileToUpload && finalfileToUpload[0] !== '') {
          <div class="image-zoom-controls">
            <button type="button" class="zoom-button" (click)="zoomIn()" aria-label="Zoom in">
              <mat-icon>zoom_in</mat-icon>
            </button>

            <button type="button" class="zoom-button" (click)="zoomOut()" aria-label="Zoom out">
              <mat-icon>zoom_out</mat-icon>
            </button>
          </div>
        }
        @if (finalfileToUpload != '' && finalfileToUpload && finalfileToUpload[0] !== '') {
          <div class="image-preview-frame">
            @if (finalfileToUpload != '' && finalfileToUpload && finalfileToUpload[0] !== '') {
              <div class="header-image-preview">
                <div
                  id="default"
                  [style.left.px]="defaultXpos"
                  [style.top.px]="defaultYpos"
                  #imageContainer
                  (mousedown)="startDrag($event)"
                  (document:mousemove)="dragImage($event)"
                  (document:mouseup)="stopDrag()"
                  class="itemimge mb-1000"
                >
                  <img
                    appFileDragNDrop
                    #imageValueData
                    class="zoom-image"
                    [style.transform]="'scale(' + zoomFactor + ')'"
                    style="border-radius: 4px; width: -webkit-fill-available !important"
                    [src]="
                      finalfileToUpload && finalfileToUpload[0] !== '' ? finalfileToUpload[0] : ''
                    "
                    alt="Preview image"
                  />
                </div>

                <button
                  type="button"
                  class="remove-image-button"
                  aria-label="Remove image"
                  (click)="remove()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        }
        <div class="fileupload-textwrap">
          @if (
            (hadderSettingImage && finalfileToUpload == '') ||
            (hadderSettingImage && (finalfileToUpload && finalfileToUpload[0]) == '')
          ) {
            <h3 style="top: 5px; position: relative">No file chosen</h3>
          }
          <p class="text-[10px] font-medium">Measurements are in 1/1000 inch.</p>
        </div>

        @if (hadderSettingImage) {
          <div>
            <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
              <mat-label>Header Image X-Pos</mat-label>
              <input
                #x
                (input)="getNewUpdatedImageXposition(x.value)"
                type="number"
                matInput
                formControlName="HEADERIMAGEXPOS"
              />
            </mat-form-field>
            <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
              <mat-label>Header Image Y-Pos</mat-label>
              <input
                #y
                (input)="getNewUpdatedImageYposition(y.value)"
                type="number"
                matInput
                formControlName="HEADERIMAGEYPOS"
              />
            </mat-form-field>
            <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
              <mat-label>Header Image Width</mat-label>
              <input
                #inputField
                type="number"
                (input)="getNewUpdatedWidth(inputField)"
                type="number"
                matInput
                formControlName="HEADERIMAGEWIDTH"
              />
            </mat-form-field>
            <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
              <mat-label>Header Image Height</mat-label>
              <input
                #inputFieldHeight
                type="number"
                (input)="getNewUpdatedHeight(inputFieldHeight)"
                matInput
                formControlName="HEADERIMAGEHEIGHT"
              />
            </mat-form-field>
          </div>
        }
      </mat-expansion-panel>
    </div>

    <div class="exoansionpanel-wrap">
      <mat-expansion-panel label="General" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          Footer Settings
        </mat-expansion-panel-header>
        <div>
          <mat-form-field class="a" appearance="outline" fxFlex="50" class="pr-10">
            <mat-label>Footer Style</mat-label>
            <!-- <input matInput formControlName="FOOTERSTYLE"> -->
            <mat-select
              #value
              formControlName="FOOTERSTYLE"
              (selectionChange)="footerimageSelect($event)"
            >
              @for (FooterStyle of GLOBLE_DROPDOWN_CONST.FooterStyle; track FooterStyle) {
                <mat-option value="{{ FooterStyle }}">{{ FooterStyle }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- <mat-form-field class="a" appearance="outline" fxFlex="50" class="pr-10" *ngIf="!FooterSettingImage">
                      <mat-label>Footer Image File</mat-label>
                      <input  matInput formControlName="FOOTERIMAGEFILE">
                    </mat-form-field> -->
          <mat-form-field class="a" appearance="outline" fxFlex="50" class="pr-10">
            <mat-label>Footer Height</mat-label>
            <input type="number" matInput formControlName="FOOTERHEIGHT" />
          </mat-form-field>
        </div>
        <!-- imge section start  -->
        @if (FooterSettingImage) {
          @if (
            finalfileToUpload_footer == '' ||
            (finalfileToUpload_footer && finalfileToUpload_footer[0]) == ''
          ) {
            <div
              class="fileupload-block mt-4 pr-10"
              appFileDragNDrop
              (filesChangeEmiter)="onFileChange_footer($event)"
            >
              <input
                type="file"
                name="file_footer"
                id="file_footer"
                (change)="onFileChange_footer($event.target.files)"
                accept="image/*"
              />
              <label for="file_footer">
                <span class="textLink">
                  <mat-icon style="position: relative; top: 4px; right: 4px">cloud_upload</mat-icon>
                  Select your file or Drop it here!
                </span>
              </label>
            </div>
          }
        }
        @if (
          FooterSettingImage &&
          finalfileToUpload_footer != '' &&
          finalfileToUpload_footer &&
          finalfileToUpload_footer[0] !== ''
        ) {
          <!-- <span
            (click)="zoomInFooter()"
            class="zoom-button"
            style="color: rgb(0, 0, 0); font-size: 40px; cursor: pointer"
          >
            zoom_in
          </span> -->

          <div class="image-zoom-controls">
            <button type="button" class="zoom-button" (click)="zoomInFooter()" aria-label="Zoom in">
              <mat-icon>zoom_in</mat-icon>
            </button>

            <button
              type="button"
              class="zoom-button"
              (click)="zoomOutFooter()"
              aria-label="Zoom out"
            >
              <mat-icon>zoom_out</mat-icon>
            </button>
          </div>
        }
        &nbsp;
        <!-- @if (
          FooterSettingImage &&
          finalfileToUpload_footer != '' &&
          finalfileToUpload_footer &&
          finalfileToUpload_footer[0] !== ''
        ) {
          <span
            (click)="zoomOutFooter()"
            class="zoom-button"
            style="color: rgb(0, 0, 0); font-size: 40px; cursor: pointer"
          >
            zoom_out
          </span>
        } -->
        @if (
          FooterSettingImage &&
          finalfileToUpload_footer != '' &&
          finalfileToUpload_footer &&
          finalfileToUpload_footer[0] !== ''
        ) {
          <div class="image-preview-frame">
            @if (
              FooterSettingImage &&
              finalfileToUpload_footer != '' &&
              finalfileToUpload_footer &&
              finalfileToUpload_footer[0] !== ''
            ) {
              <div class="footer-image-preview">
                <!-- Draggable / zoomable footer image -->
                <div
                  #imageFooterContainer
                  (mousedown)="startDragfooter($event)"
                  (document:mousemove)="dragImagefooter($event)"
                  (document:mouseup)="stopDragfooter()"
                  class="itemimge mb-1000-footer"
                >
                  <img
                    appFileDragNDrop
                    class="zoom-image"
                    [style.transform]="'scale(' + zoomFooter + ')'"
                    style="border-radius: 4px; width: -webkit-fill-available !important"
                    [src]="
                      finalfileToUpload_footer && finalfileToUpload_footer[0] !== ''
                        ? finalfileToUpload_footer[0]
                        : ''
                    "
                    alt="Preview image"
                  />
                </div>

                <!-- Fixed remove button -->
                <button
                  type="button"
                  class="remove-image-button"
                  aria-label="Remove footer image"
                  (click)="remove_footer()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        }
        <div class="fileupload-textwrap">
          @if (
            (FooterSettingImage && finalfileToUpload_footer == '') ||
            (FooterSettingImage && (finalfileToUpload_footer && finalfileToUpload_footer[0]) == '')
          ) {
            <h3 style="top: 5px; position: relative">No file chosen</h3>
          }
          <p class="text-[10px] font-medium">Measurements are in 1/1000 inch.</p>
        </div>

        @if (FooterSettingImage) {
          <div>
            <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
              <mat-label>Footer Image X-Pos</mat-label>
              <input
                #xfooter
                (input)="getNewUpdatedImageXpositionOfFooter(xfooter.value)"
                type="number"
                matInput
                formControlName="FOOTERIMAGEXPOS"
              />
            </mat-form-field>
            <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
              <mat-label>Footer Image Y-Pos</mat-label>
              <input
                #yfooter
                (input)="getNewUpdatedImageYpositionOfFooter(yfooter.value)"
                type="number"
                matInput
                formControlName="FOOTERIMAGEYPOS"
              />
            </mat-form-field>
            <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
              <mat-label>Footer Image Width</mat-label>
              <input
                #inputOfImageWidth
                type="number"
                (input)="getNewUpdatedWidthOfFooter(inputOfImageWidth)"
                type="number"
                matInput
                formControlName="FOOTERIMAGEWIDTH"
              />
            </mat-form-field>
            <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
              <mat-label>Footer Image Height</mat-label>
              <input
                #inputOfImageHeight
                (input)="getNewUpdatedHeightOfFooter(inputOfImageHeight)"
                type="number"
                matInput
                formControlName="FOOTERIMAGEHEIGHT"
              />
            </mat-form-field>
          </div>
        }
      </mat-expansion-panel>
    </div>

    <div class="exoansionpanel-wrap">
      <mat-expansion-panel label="General" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          General Layout
        </mat-expansion-panel-header>
        <div class="flexblock-field flexblock-wrap">
          <!-- <mat-form-field class="a" appearance="outline" fxFlex="33.33"
                                  class="pr-10">
                                  <mat-label>Invoice Title</mat-label>
                                  <textarea matInput formControlName="TAXINVOICETITLE" class="Invoice_Title"></textarea>
                                </mat-form-field> -->

          <mat-form-field appearance="outline" class="full-width pr-1 pb-6" fxFlex="100">
            <mat-label>Invoice Title</mat-label>

            <textarea
              matInput
              formControlName="TAXINVOICETITLE"
              rows="3"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
          </mat-form-field>
          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="pr-10">
            <mat-label>ABN Location</mat-label>
            <!-- <input  matInput formControlName="ABNLOCATION"> -->
            <mat-select #value formControlName="ABNLOCATION">
              @for (ABNLocation of GLOBLE_DROPDOWN_CONST.ABNLocation; track ABNLocation) {
                <mat-option value="{{ ABNLocation }}">{{ ABNLocation }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="pr-10">
            <mat-label>Reline Justification</mat-label>
            <!-- <input type="text" matInput formControlName="RELINEJUSTIFICATION"> -->
            <mat-select #value formControlName="RELINEJUSTIFICATION">
              @for (
                RELINEJustification of GLOBLE_DROPDOWN_CONST.RELINEJustification;
                track RELINEJustification
              ) {
                <mat-option value="{{ RELINEJustification }}">
                  {{ RELINEJustification }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flexblock-field flexblock-wrap">
          <!-- <mat-form-field class="a" appearance="outline"
                                fxFlex="33.33" class="pr-10">
                                <mat-label>Person Responsible</mat-label>
                                <mat-select #value formControlName="PERSONRESPONSIBLE">
                                  <mat-option
                                    *ngFor="let PERSONResposible of GLOBLE_DROPDOWN_CONST.PERSONResposible"
                                    value="{{PERSONResposible}}">{{PERSONResposible}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field> -->
          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="mt-6 pr-10 pb-6">
            <input matInput placeholder="Date Format" formControlName="DATEFORMAT" />
          </mat-form-field>
          <mat-slide-toggle fxFlex="33.33" formControlName="SHOWCOURTDETAILS">
            Show Court Details
          </mat-slide-toggle>
          <mat-slide-toggle fxFlex="33.33" formControlName="SHOWMATTERREFERENCE">
            Show Matter Reference
          </mat-slide-toggle>
          <mat-slide-toggle fxFlex="33.33" formControlName="INDENTADDRESSEEDETAILS" class="pb-6">
            Indent Addressee details
          </mat-slide-toggle>
          <mat-slide-toggle fxFlex="33.33" formControlName="SHOWADDRESSEEPOSITION" class="pb-6">
            Show Addressee Position
          </mat-slide-toggle>
          <mat-slide-toggle fxFlex="33.33" formControlName="SHOWADDRESSEEEMAIL" class="pb-6">
            Show Addressee Email
          </mat-slide-toggle>
          <mat-form-field appearance="outline" fxFlex="33.33" class="pr-10 pb-6">
            <mat-label>Matter No Location</mat-label>
            <mat-select formControlName="MATTERNOLOCATION">
              <mat-option value="Above Invoice No">Above Invoice No</mat-option>
              <mat-option value="Above Date">Above Date</mat-option>
              <mat-option value="None">None</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="33.33" class="pr-10 pb-6">
            <mat-label>Matter No Format</mat-label>
            <mat-select formControlName="MATTERNOFORMAT">
              <mat-option value="MatterNo">MatterNo</mat-option>
              <mat-option value="OWN:MatterNo">OWN:MatterNo</mat-option>
              <mat-option value="PFE:MatterNo">PFE:MatterNo</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flexblock-field flexblock-wrap">
          <mat-form-field appearance="outline" fxFlex="33.33" class="pr-10">
            <mat-label>Invoice No Position</mat-label>
            <mat-select formControlName="INVOICENUMBERPOSITION">
              <mat-option value="Left">Left</mat-option>
              <mat-option value="Right">Right</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-slide-toggle
            style="align-items: baseline !important"
            formControlName="PADZEROSINVOICENUMBER"
          >
            Pad Invoice No with leading zeros
          </mat-slide-toggle>
        </div>
        <!-- <div class="flexblock-wrap">
                            </div> -->
      </mat-expansion-panel>
    </div>
    <div class="exoansionpanel-wrap">
      <mat-expansion-panel label="Summary" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          Summary Information
        </mat-expansion-panel-header>
        <div class="summary-block mb-4">
          <mat-slide-toggle class="m-[10px]" formControlName="SHOWFIRSTPAGESUMMARY">
            Show First Page Summary
          </mat-slide-toggle>
          <mat-slide-toggle class="m-[10px]" formControlName="SHOWDATERANGEONFEES">
            Append Date Range to Fees Description
          </mat-slide-toggle>
          <div>
            <mat-form-field class="a" appearance="outline" fxFlex="100" class="pr-10 pb-6">
              <mat-label>Fees Description</mat-label>
              <input type="text" matInput formControlName="FEESDESCRIPTION" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="a" appearance="outline" fxFlex="100" class="pr-10 pb-6">
              <mat-label>Disbursement Description</mat-label>
              <input type="text" matInput formControlName="DISBURSEMENTDESCRIPTION" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="a" appearance="outline" fxFlex="100" class="pr-10 pb-6">
              <mat-label>Trust Authority Statement</mat-label>
              <input type="text" matInput formControlName="TRUSTAUTHORITYSTATEMENT" />
            </mat-form-field>
          </div>
        </div>
        <div>
          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="pr-10">
            <mat-label>Show Solicitor Summary</mat-label>
            <!-- <input type="text" matInput formControlName="SHOWSOLICITORSUMMARY"> -->
            <mat-select #value formControlName="SHOWSOLICITORSUMMARY">
              @for (
                SHOWSolicitorSummary of GLOBLE_DROPDOWN_CONST.SHOWSolicitorSummary;
                track SHOWSolicitorSummary
              ) {
                <mat-option value="{{ SHOWSolicitorSummary }}">
                  {{ SHOWSolicitorSummary }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="pr-10">
            <mat-label>Solicitor Summary Style</mat-label>
            <!-- <input type="text" matInput formControlName="SOLSUMMARYSTYLE"> -->
            <mat-select #value formControlName="SOLSUMMARYSTYLE">
              @for (
                SOLSUMMARYSTYLE of GLOBLE_DROPDOWN_CONST.SOLSUMMARYSTYLE;
                track SOLSUMMARYSTYLE
              ) {
                <mat-option value="{{ SOLSUMMARYSTYLE }}">
                  {{ SOLSUMMARYSTYLE }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="pr-10">
            <mat-label>Show Deliverable Summary</mat-label>
            <!-- <input type="text" matInput formControlName="SHOWDELIVERABLESUMMARY"> -->
            <mat-select #value formControlName="SHOWDELIVERABLESUMMARY">
              @for (
                SHOWDelivarableSummary of GLOBLE_DROPDOWN_CONST.SHOWDelivarableSummary;
                track SHOWDelivarableSummary
              ) {
                <mat-option value="{{ SHOWDelivarableSummary }}">
                  {{ SHOWDelivarableSummary }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </mat-expansion-panel>
    </div>
    <div class="exoansionpanel-wrap">
      <mat-expansion-panel label="General" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          Financial Details
        </mat-expansion-panel-header>
        <b>Items to show in invoice summary</b>
        <br />
        <br />
        <div class="flexblock-wrap">
          <mat-slide-toggle class="pb-6" formControlName="SHOWWRITTENOFFAMOUNT">
            Show Written Off Amount
          </mat-slide-toggle>
          <mat-slide-toggle class="pb-6" formControlName="SHOWRECEIVEDAMOUNT">
            Show Received Amount
          </mat-slide-toggle>
          <mat-slide-toggle class="pb-6" formControlName="SHOWBILLINGRECIPIENT">
            Show Billing Recipient
          </mat-slide-toggle>
          <mat-slide-toggle class="pb-6" formControlName="SHOWTRUSTBALANCES">
            Show Trust Balances
          </mat-slide-toggle>
          <mat-slide-toggle class="pb-6" formControlName="SHOWFOREIGNCURRENCY">
            Show Foreign Currency
          </mat-slide-toggle>
          <mat-slide-toggle class="pb-6" formControlName="GROUPSECRETARIALWORK">
            Group Secretarial Work
          </mat-slide-toggle>
          <mat-slide-toggle class="pb-6" formControlName="ADDEANDOELINE">
            Add E&OE line
          </mat-slide-toggle>
          <mat-form-field appearance="outline" fxFlex="25" class="pb-6">
            <mat-label>Summary Label Position</mat-label>
            <!-- <input type="text" matInput formControlName="OUTSTANDINGTABLE"> -->
            <mat-select formControlName="SUMMARYLABELPOSITION">
              <mat-option value="Left">Left</mat-option>
              <mat-option value="Right">Right</mat-option>
            </mat-select>
          </mat-form-field>
          <br />
        </div>
        <div>
          <mat-form-field appearance="outline" fxFlex="100" class="pr-10 pb-6">
            <mat-label>But Say Text</mat-label>
            <input type="text" matInput formControlName="BUTSAYTEXT" />
          </mat-form-field>
        </div>

        <b>Outstanding Invoices</b>
        <br />
        <br />
        <div class="flexblock-wrap items-start!">
          <mat-form-field class="a pr-10" appearance="outline" fxFlex="33">
            <mat-label>Outstanding Table</mat-label>
            <!-- <input type="text" matInput formControlName="OUTSTANDINGTABLE"> -->
            <mat-select #value formControlName="OUTSTANDINGTABLE">
              @for (
                OUTStandingTable of GLOBLE_DROPDOWN_CONST.OUTStandingTable;
                track OUTStandingTable
              ) {
                <mat-option value="{{ OUTStandingTable }}">
                  {{ OUTStandingTable }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (InvoiceTemplatePopup.get('OUTSTANDINGTABLE')?.value !== 'None') {
            <div class="flexblock-wrap w-[65%]!">
              <mat-slide-toggle class="pb-6" formControlName="OUTSTANDINGSHOWWRITTENOFF">
                Show Written Off Amount
              </mat-slide-toggle>
              <mat-slide-toggle class="pb-6" formControlName="OUTSTANDINGSHOWINTEREST">
                Show Interest Amount
              </mat-slide-toggle>
              <mat-slide-toggle class="pb-6" formControlName="DONTSHOWOTHEROUTSTANDING">
                Don't Show On Summary Page
              </mat-slide-toggle>
            </div>
          }
        </div>
      </mat-expansion-panel>
    </div>

    <div class="exoansionpanel-wrap">
      <mat-expansion-panel label="General" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          Signature Details
        </mat-expansion-panel-header>
        <div class="flexblock-field flexblock-wrap">
          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="pr-10 pb-6">
            <mat-label>With Compliments</mat-label>
            <input
              matInput
              placeholder="With Compliments Text"
              formControlName="WITHCOMPLIMENTSTEXT"
            />
          </mat-form-field>
          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="pr-10 pb-6">
            <mat-label>Show With Compliments</mat-label>
            <!-- <input type="text" matInput formControlName="SHOWSTATEMENTS"> -->
            <mat-select #value formControlName="SHOWWITHCOMPLIMENTS">
              @for (
                SHOWStatement of GLOBLE_DROPDOWN_CONST.ShowWithCompliments;
                track SHOWStatement
              ) {
                <mat-option value="{{ SHOWStatement }}">
                  {{ SHOWStatement }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-slide-toggle fxFlex="33.33" formControlName="SHOWPERSONRESPONSIBLEEMAIL">
            Person Responsible Email
          </mat-slide-toggle>
          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="pr-10 pb-6">
            <mat-label>Person Responsible</mat-label>
            <!-- <input type="text" matInput formControlName="PERSONRESPONSIBLE"> -->
            <mat-select #value formControlName="PERSONRESPONSIBLE">
              @for (
                PERSONResposible of GLOBLE_DROPDOWN_CONST.PERSONResposible;
                track PERSONResposible
              ) {
                <mat-option value="{{ PERSONResposible }}">
                  {{ PERSONResposible }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="a" appearance="outline" fxFlex="33.33" class="pr-10 pb-6">
            <mat-label>Person Responsible Title</mat-label>
            <!-- <input type="text" matInput formControlName="PERSONRESPONSIBLE"> -->
            <mat-select #value formControlName="PERSONRESPONSIBLETITLE">
              <mat-option value="Title Responsible">Title Responsible</mat-option>
              <mat-option value="Title Under Name">Title Under Name</mat-option>
              <mat-option value="None">None</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- <mat-slide-toggle style="align-items: baseline !important" formControlName="SHOWADDRESSEEEMAIL">Show Addressee Email</mat-slide-toggle> -->
        </div>

        <div class="flexblock-wrap">
          <!-- <mat-slide-toggle formControlName="SHOWWITHCOMPLIMENTS">Show With Compliments</mat-slide-toggle>  -->
          <mat-slide-toggle class="pb-6" formControlName="HIDEPRACTICENAME">
            Hide Practice Name
          </mat-slide-toggle>
        </div>

        <div class="flexblock-wrap">
          <!-- <mat-form-field class="a bank-text" appearance="outline" fxFlex="100">
                                      <textarea matInput formControlName="STATEMENTAFTERSIGNATURE" placeholder="Statement after Signature"></textarea>
                                    </mat-form-field> -->

          <mat-form-field appearance="outline" class="matter-textarea-wrapper pr-1" fxFlex="100">
            <mat-label>Statement after Signature</mat-label>

            <textarea
              matInput
              formControlName="STATEMENTAFTERSIGNATURE"
              rows="4"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
          </mat-form-field>
          <!-- </div> -->
        </div>
      </mat-expansion-panel>
    </div>

    <div class="exoansionpanel-wrap">
      <mat-expansion-panel label="General" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          Statements
        </mat-expansion-panel-header>
        <div class="mb-4">
          <mat-form-field class="a" appearance="outline" fxFlex="50" class="pr-10">
            <mat-label>Show Statements</mat-label>
            <!-- <input type="text" matInput formControlName="SHOWSTATEMENTS"> -->
            <mat-select #value formControlName="SHOWSTATEMENTS">
              @for (SHOWStatement of GLOBLE_DROPDOWN_CONST.SHOWStatement; track SHOWStatement) {
                <mat-option value="{{ SHOWStatement }}">
                  {{ SHOWStatement }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flexblock-wrap">
          <!-- <mat-slide-toggle formControlName="SHOWWITHCOMPLIMENTS">Show With Compliments</mat-slide-toggle>  -->
          <mat-slide-toggle formControlName="SHOWSTATEMENT2">Show Statement 2</mat-slide-toggle>
          <mat-slide-toggle formControlName="SHOWSTATEMENT3">Show Statement 3</mat-slide-toggle>
          <mat-slide-toggle formControlName="SHOWSTATEMENT4">Show Statement 4</mat-slide-toggle>
        </div>
      </mat-expansion-panel>
    </div>

    <div class="exoansionpanel-wrap">
      <mat-expansion-panel label="General" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          Remittance
        </mat-expansion-panel-header>
        <div fxLayout="row" class="mb-4">
          <mat-form-field class="a" appearance="outline" fxFlex="30" class="pr-10">
            <mat-label>Show Remittance</mat-label>
            <!-- <input type="text" matInput formControlName="SHOWREMITTANCE"> -->
            <mat-select #value formControlName="SHOWREMITTANCE">
              @for (SHOWRemittance of GLOBLE_DROPDOWN_CONST.SHOWRemittance; track SHOWRemittance) {
                <mat-option value="{{ SHOWRemittance }}">
                  {{ SHOWRemittance }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-slide-toggle fxFlex="70" formControlName="SHOWBANKDETAILSDONTCHANGE">
            Show Bank Details Don't Change Statement
          </mat-slide-toggle>
        </div>

        <div fxLayout="row" class="mb-4">
          <!-- <mat-form-field class="a bank-text" appearance="outline" fxFlex="100">
                                  <mat-label><b>Bank details don't change statement</b></mat-label>
                                  <textarea matInput formControlName="BANKDETAILSDONTCHANGE" placeholder="Bank Details Text"></textarea>
                                </mat-form-field> -->

          <mat-form-field appearance="outline" class="matter-textarea-wrapper pr-1" fxFlex="100">
            <mat-label>
              <b>Bank details don't change statement</b>
            </mat-label>

            <textarea
              matInput
              formControlName="BANKDETAILSDONTCHANGE"
              rows="4"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="flexblock-wrap mb-4">
          <mat-slide-toggle formControlName="SHOWMAILOPTION">Show Mail Option</mat-slide-toggle>
          <mat-slide-toggle formControlName="SHOWCREDITCARDOPTION">
            Show Credit Card Option
          </mat-slide-toggle>
          <mat-slide-toggle formControlName="SHOWDIRECTDEBITOPTION">
            Show Direct Debit Option
          </mat-slide-toggle>
        </div>

        <div fxLayout="row">
          <mat-form-field class="a" appearance="outline" fxFlex="30" class="pr-2">
            <mat-label>Direct Debit Account</mat-label>
            <mat-select
              formControlName="DIRECTDEBITACCOUNT"
              (selectionChange)="onDirectDebitChange($event)"
            >
              @for (
                DIRECTDEBITACCOUNTRemittance of GLOBLE_DROPDOWN_CONST.DIRECTDEBITACCOUNTRemittance;
                track DIRECTDEBITACCOUNTRemittance
              ) {
                <mat-option value="{{ DIRECTDEBITACCOUNTRemittance }}">
                  {{ DIRECTDEBITACCOUNTRemittance }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (isShowAccountInfo == true) {
            <mat-form-field class="a" appearance="outline" fxFlex="15" class="pr-2">
              <mat-label>BSB</mat-label>
              <input type="text" matInput formControlName="DIRECTDEBITBSB" />
            </mat-form-field>
            <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-2">
              <mat-label>A/C Number</mat-label>
              <input type="text" matInput formControlName="DIRECTDEBITACCOUNTNO" />
            </mat-form-field>
            <mat-form-field class="a" appearance="outline" fxFlex="30" class="pr-2">
              <mat-label>Account Name</mat-label>
              <input type="text" matInput formControlName="DIRECTDEBITACCOUNTNAME" />
            </mat-form-field>
          }
        </div>
      </mat-expansion-panel>
    </div>

    <div class="exoansionpanel-wrap">
      <mat-expansion-panel label="General" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          Work Items
        </mat-expansion-panel-header>
        <div class="flexblock-wrap mb-4">
          <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
            <mat-label>Show Taxes As</mat-label>
            <!-- <input type="text" matInput formControlName="SHOWTAXESAS"> -->
            <mat-select #value formControlName="SHOWREMITTANCE">
              @for (SHOWRemittance of GLOBLE_DROPDOWN_CONST.SHOWRemittances; track SHOWRemittance) {
                <mat-option value="{{ SHOWRemittance }}">
                  {{ SHOWRemittance }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
            <mat-label>Display Quantity Type</mat-label>
            <!-- <input type="text" matInput formControlName="DISPLAYQUANTITYTYPE"> -->
            <mat-select #value formControlName="DISPLAYQUANTITYTYPE">
              @for (
                DISPLAYQuantitiyType of GLOBLE_DROPDOWN_CONST.DISPLAYQuantitiyType;
                track DISPLAYQuantitiyType
              ) {
                <mat-option value="{{ DISPLAYQuantitiyType }}">
                  {{ DISPLAYQuantitiyType }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
            <mat-label>Show WorkItem Quantity</mat-label>
            <!-- <input type="text" matInput formControlName="SHOWWORKITEMQUANTITY"> -->
            <mat-select #value formControlName="SHOWWORKITEMQUANTITY">
              @for (
                SHOWWorkItemQuantity of GLOBLE_DROPDOWN_CONST.SHOWWorkItemQuantity;
                track SHOWWorkItemQuantity
              ) {
                <mat-option value="{{ SHOWWorkItemQuantity }}">
                  {{ SHOWWorkItemQuantity }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="a" appearance="outline" fxFlex="25" class="pr-10">
            <mat-label>Show Disbursement Payee</mat-label>
            <!-- <input type="text" matInput formControlName="SHOWDISBURSEMENTPAYEE"> -->
            <mat-select #value formControlName="SHOWDISBURSEMENTPAYEE">
              @for (
                SHOWDistrubmentPayee of GLOBLE_DROPDOWN_CONST.SHOWDistrubmentPayee;
                track SHOWDistrubmentPayee
              ) {
                <mat-option value="{{ SHOWDistrubmentPayee }}">
                  {{ SHOWDistrubmentPayee }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-justify mb-4 flex">
          <mat-slide-toggle formControlName="HIDETIMEENTRIES">Hide Time Entries</mat-slide-toggle>
          <mat-slide-toggle formControlName="USEDELIVERABLES">Use Deliverables</mat-slide-toggle>
          <mat-slide-toggle formControlName="SHOWINDIVIDUALCOSTS">
            Show Individual Costs
          </mat-slide-toggle>
          <mat-slide-toggle formControlName="SHOWFEEEARNER">Show Fee Earner</mat-slide-toggle>
        </div>
        <div class="flex-justify-start flex">
          <mat-slide-toggle formControlName="SHOWDATESONCE">Show Dates Once</mat-slide-toggle>
          <mat-slide-toggle style="margin-left: 49px" formControlName="SHOWDISBURSEMENTSONNEWPAGE">
            Insert Page Break before Disbursements
          </mat-slide-toggle>
        </div>
      </mat-expansion-panel>
    </div>
  </div>

  <mat-dialog-actions class="popup_ftr justify-end!">
    @if (_data.Type == 'edit' || _data.Type == 'new') {
      <button
        matButton="filled"
        class="mat-accent"
        [disabled]="isspiner"
        (click)="SaveData('Preview')"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Preview
      </button>
    }
    @if (_data.Type == 'new') {
      <button
        matButton="filled"
        class="mat-accent"
        [disabled]="isspiner"
        (click)="SaveData(_data.Type)"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
    }
    @if (_data.Type == 'edit') {
      <button
        matButton="filled"
        class="mat-accent"
        [disabled]="isspiner"
        (click)="SaveData(_data.Type)"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Update
      </button>
    }
    @if (_data.Type == 'duplicate') {
      <button
        matButton="filled"
        class="mat-accent"
        [disabled]="isspiner"
        (click)="SaveData(_data.Type)"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Duplicate
      </button>
    }
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don`t Save</button>
  </mat-dialog-actions>
</div>
<!-- </form> -->
